import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseAPIArray, BaseAPIObject, BaseApiService } from "../services/base-api.service";
import { HelpersService } from "../services/helpers.service";
import { ProgressService } from "../services/progress.service";
import { LoadingService } from "../services/loading.service";
import { share } from "rxjs";
import { HttpQuery } from "../services/http-query";

@Injectable({
  providedIn: 'root',
})
export class ReimburseService extends BaseApiService<any> {
  constructor(
    public override http: HttpClient,
    public override helper: HelpersService,
    public override loading: ProgressService,
    public override loadingService: LoadingService,
  ) {
    super(http, helper, loading, loadingService);
    this.endpoint = 'reimburse';
    this.query = { limit: 0, page: 0 };
  }

  getAllApprove(userId: any, query?: HttpQuery, notifyChange: Boolean = true): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('approval/paging');
      let params = query ? this.helper.generateParams(query) : {};
      if (userId != null) {
        if (params instanceof HttpParams) {
          params = params.append('userId', userId)
        } else {
          let paramNew = new HttpParams()
          paramNew = paramNew.append('userId', userId)
          params = paramNew
        }
      }
      if (Object.keys(params).length == 0) {
        return resolve(this.data);
      }
      this.loadingService.startLoading();
      this.http.get<BaseAPIArray<any>>(url, { params }).subscribe({
        next: ({ data, total }) => {
          this.data = data;
          this.dataLength = total;
          if (notifyChange) {
            this.onDataChanged.next(this.data);
            this.onDataLengthChanged.next(this.dataLength);
          }
          this.loadingService.endLoading()
          return resolve(this.data);
        },
        error: (err) => this.handleError(err, reject),
      });
    });
  }

  getCountStatus(): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['count', 'by-status']);
      this.loadingService.startLoading()
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  getCountStatusApproval(): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['count', 'by-status', 'approval']);
      this.loadingService.startLoading()
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  getCountStatusFinance(): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['count', 'by-status', 'finance']);
      this.loadingService.startLoading()
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  getApprovalList(reimburseId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('approval/list');
      let params = new HttpParams()
      params = params.append('reimburseId', reimburseId)
      this.loadingService.startLoading()
      this.http
        .get<any>(url, { params })
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  approve(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('approval/approve');
      this.loadingService.startLoading()
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  approveFinance(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('approval/approve/finance');
      this.loadingService.startLoading()
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  reject(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('approval/reject');
      this.loadingService.startLoading()
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  close(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['close', id]);
      this.loadingService.startLoading()
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
  
  reimburse(id: any, data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['resubmit', id]);
      this.loadingService.startLoading();
      this.http
        .post<BaseAPIObject<any>>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
}
